import React from "react";

export function MoneyBankIcon({ vectorEffect, ...rest }: React.ComponentProps<"svg">) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="money-bank--institution-money-saving-bank-payment-finance 1--Streamline-Core">
        <g id="Group">
          <path
            id="Vector"
            d="M25.8201 11H2.18013C1.06013 11 0.580131 9.77999 1.46013 9.19999L13.2801 1.45999C13.4984 1.33161 13.7469 1.26392 14.0001 1.26392C14.2533 1.26392 14.5019 1.33161 14.7201 1.45999L26.5401 9.19999C27.4201 9.77999 26.9401 11 25.8201 11Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
          <path
            id="Vector_2"
            d="M26 22H2C1.44772 22 1 22.4477 1 23V26C1 26.5523 1.44772 27 2 27H26C26.5523 27 27 26.5523 27 26V23C27 22.4477 26.5523 22 26 22Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
          <path
            id="Vector_3"
            d="M4 11V22"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
          <path
            id="Vector_4"
            d="M9 11V22"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
          <path
            id="Vector_5"
            d="M14 11V22"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
          <path
            id="Vector_6"
            d="M19 11V22"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
          <path
            id="Vector_7"
            d="M24 11V22"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
        </g>
      </g>
    </svg>
  );
}
